import React, { useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';
import AppModal from '../../../../components/Modal/AppModal';

export default function Report36OnlineInfo(props) {
  const { data } = props;
  const [showModal, setShowModal] = useState(false);
  const [selectedModalInfo, setSelectedModalInfo] = useState(null);

  return (
    <div className="row  mt-3">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">
                    <Translator file="module-intelligence" name="plant" />
                  </th>
                  <th scope="col">
                    <Translator
                      file="module-intelligence"
                      name="stored.milestones"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.onlineInfo.yAxis.map((y, i) => (
                  <tr key={i}>
                    <th scope="row">{y.title}</th>
                    <td>
                      {y.data.length > 0 ? (
                        <span
                          className="btn btn-xs btn-info"
                          onClick={() => {
                            setSelectedModalInfo(y.data);
                            setShowModal(true);
                          }}
                        >
                          {y.data.length}
                        </span>
                      ) : (
                        0
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <AppModal
        show={showModal}
        title={ReactDOMServer.renderToString(
          <Translator file="module-intelligence" name="info" />
        )}
        onClose={() => setShowModal(false)}
      >
        <div style={{ overflowY: 'scroll', maxHeight: '300px' }}>
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">
                  <Translator file="module-intelligence" name="date" />
                </th>
                <th scope="col">
                  <Translator file="module-intelligence" name="name" />
                </th>
              </tr>
            </thead>
            <tbody>
              {selectedModalInfo &&
                selectedModalInfo.map((m, i) => (
                  <tr key={i}>
                    <td>{m.date}</td>
                    <th scope="row">{m.name}</th>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </AppModal>
    </div>
  );
};
